"use client";

import * as React from "react";

export interface PageFabProps {
  children?: React.ReactNode;
}

export function PageFab({ children }: PageFabProps) {
  if (!children) return null;
  return <>{children}</>;
}
